import { FunctionalComponent, h } from 'preact';
import styled from 'styled-components';

export const ButtonLink = styled.button`
  align-items: center;
  background: none !important;
  border: none;
  color: #0045a5;
  cursor: pointer;
  display: inline-flex;
  font-size: ${({ theme }) => theme.typography.size.medium};
  margin-top: 1px;
  outline: none;
  padding: 0 !important;
  text-decoration: none;

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const Label = styled.label`
  color: #0045a5;
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.size.medium};
  margin-right: ${({ theme }) => theme.spacing.base.xxs};
  text-decoration: none;
`;

export const UpArrow = styled.i`
  border: solid #0045a5;
  border-width: 0 2px 2px 0;
  height: 8px;
  padding: ${({ theme }) => theme.spacing.base.xxs};
  transform: translate(0, 3.3px) rotate(-135deg);
  width: 8px;
`;

export const DownArrow = styled.i`
  border: solid #0045a5;
  border-width: 0 2px 2px 0;
  height: 8px;
  margin-top: -${({ theme }) => theme.spacing.base.xxs};
  padding: ${({ theme }) => theme.spacing.base.xxs};
  transform: rotate(45deg);
  width: 8px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${({ theme }) => theme.spacing.base.sm};
  flex: auto;
  flex-wrap: wrap;
  max-width: 100%;
  max-height: 100%;
`;

export const ContentWrapper: FunctionalComponent = ({ children }) => {
  return <Content>{children}</Content>;
};

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  height: 16px;
  justify-content: center;
  width: 16px;
`;

export const ErrorContainer = styled.div`
  align-content: center;
  border: 1px solid ${({ theme }) => theme.color.neutral.default};
  display: inline-flex;
  flex-direction: row;
  height: 58px;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.base.sm};
`;

type TextProps = {
  size?: number;
};

export const Text = styled.div<TextProps>`
  align-items: center;
  display: flex;
  flex: ${({ size }) => size || 'initial'};
`;

export const TextMedium = styled(Text)<TextProps>`
  font-size: ${({ theme }) => theme.typography.size.medium};
  justify-content: center;
`;
